module.exports = __webpack_public_path__ + "img/valerib (1).acc73dbe.jpg";